import { useNavigate } from "react-router-dom";

import { BannerStructure } from "../RootBanner";

export const ProfitBanner = ({
  onClickLeft,
  onClickRight,
}: {
  onClickLeft: () => void;
  onClickRight: () => void;
}) => {
  const navigate = useNavigate();
  const handleOnClickCTA = () => {
    navigate("/subscription");
  };
  return (
    <BannerStructure
      bgUrl="bg-[url('https://cdn.easysbc.io/fc25/banners/profitbanner/profitbanner.png')]"
      title="Manage your club like never before. See SBC fodder and spot easy profit."
      learnMoreLink="/get-my-players"
      onClickCTA={handleOnClickCTA}
      onClickLeft={onClickLeft}
      onClickRight={onClickRight}
    >
      <div
        className="h-full w-full absolute bottom-0 touch-device:hidden"
        style={{
          background:
            "linear-gradient(0deg, #1A1E23 53.65%, rgba(26, 30, 35, 0.00) 100%)",
        }}
      />
      <img
        className="absolute h-72 object-cover touch-device:h-90 touch-device:top-4 large-desktop:h-[503px] touch-device:right-8 -top-8 large-desktop:-top-16"
        src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc25/banners/profitbanner/profitgraphic.png`}
        alt="profitbanner"
      />
    </BannerStructure>
  );
};
